
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Les Vert’libéraux sont les deuxièmes grands gagnants du week-end électoral. À l'exception du canton de Berne, ils n'ont réalisé des gains que dans les centres urbains et le Plateau suisse (Berne, Fribourg, Jura, Neuchâtel, Soleure). Dans de nombreux cantons ruraux, le PVL n’est que faiblement représenté.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;